import { REPORT_STATUS } from '../../types/reports';

/**
 * How often the auto-opener checks a watched document. Each check is one
 * primary-key lookup (POST api/report/Status), so it can be frequent: the gap
 * between the render pool finishing and the viewer / print dialog opening
 * averages half of this. It was 2.5 s against the whole print queue.
 */
export const AUTO_OPEN_POLL_MS = 1000;

/** What to do with a watched document in a given status. */
export type WatchedOutcome = 'open' | 'noData' | 'error' | 'canceled' | 'info' | 'wait';

/**
 * Maps a tblRS_ReportDocument status to the auto-opener's next step.
 * Completed and Printed open (a document can be marked viewed or printed,
 * both Printed in the table, by another path before the next check). Required Information / Information / Info
 * Select (5-7) end the wait too: the generator answered with a message, not a
 * document, and waiting on them used to leave the spinner up forever.
 */
export function outcomeForStatus(status: number, guid: string | null | undefined): WatchedOutcome {
  switch (status) {
    case REPORT_STATUS.PENDING:
    case REPORT_STATUS.GENERATING:
      return 'wait';
    case REPORT_STATUS.COMPLETED:
    case REPORT_STATUS.PRINTED:
      return guid ? 'open' : 'wait';
    case REPORT_STATUS.NO_DATA:
      return 'noData';
    case REPORT_STATUS.ERROR:
      return 'error';
    case REPORT_STATUS.CANCELED:
      return 'canceled';
    case REPORT_STATUS.REQUIRED_INFO:
    case REPORT_STATUS.INFORMATION:
    case REPORT_STATUS.INFO_SELECT:
      return 'info';
    default:
      return 'wait';
  }
}
